<template>
  <div class="all_pay">
    <div>
      <el-dialog
        :title="`请使用${pattern_payment=='1'?'支付宝':'微信'}扫描二维码进行付款`"
        :visible.sync="centerDialogVisible"
        width="350px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleBeforeClose"
        center>
        <span>
          <img class="qrcode" :src="qr_img" alt="">
        </span>
      </el-dialog>
    </div>
    <p class="bold" style="color:red;margin-top:20px">公告：</p>
    <p class="bold" style="color:red">1、由于数据库资源有限，为长期保障VIP客户的体验，本站自即日起只保留VIP4套餐续费，并鼓励对公交易，敬请新老客户理解；</p>
    <p class="bold" style="color:red">2、本站不再接受任何信息类公司的账户申请和续费，任何采用计算机程序大量下载资源的账户一经发现直接删除账户并封锁相关IP段，且不支持退款。</p>
    <p class="bold" style="color:red;margin-bottom:40px">3、注意: 无法充值的用户请联系客服处理!!!</p>
    <p class="bold">请选择要购买的充值类型：</p>
    <el-radio-group v-model="vip">
      <el-radio
        v-for="(item,index) in vip_grade"
        :label="item.id"
        :key="index"
        class="vip_select">
        {{item.vip}}
      </el-radio>
    </el-radio-group>
    <p class="title bold">请选择支付方式：</p>
    <div class="pay-opt">
      <el-radio v-model="pattern_payment" label="2" border>
        <img src="./../../../public/WeChatPay.png" alt="">
      </el-radio>
      <el-radio v-model="pattern_payment" label="1" border>
        <img src="./../../../public/Alipay.png" alt="">
      </el-radio>
      <!-- <span v-if="!is_wx" style="font-size:11px; color:#bbb;cursor: pointer;" @click="is_wx=!is_wx">more>></span>
      <el-radio v-else v-model="pattern_payment" label="1" border>
        <img src="./../../../public/Alipay.png" alt="">
      </el-radio> -->
      <!-- <el-radio v-else  v-model="pattern_payment" label="2" border>
        <img src="./../../../public/WeChatPay.png" alt="">
      </el-radio>
      <el-radio v-model="pattern_payment" label="2" border>
        <img src="./../../../public/WeChatPay.png" alt="">
      </el-radio> -->
    </div>
    <p class="title bold">请选择并发访问线程（同时访问人数）：
      <el-input-number size="mini" v-model="num" :min="1" :max="100"></el-input-number>
    </p>
    <p>
      <span class="sum_price">总金额：{{sum_price}} 元</span>
      <span class="btn" @click="recharge">马上充值</span>
    </p>
    <p class="notice">重要!!! 支付成功待出现“充值成功”提示后，再关闭支付页面，否者系统可能不会自动延长您的使用时间。</p>
    <el-dialog
      :title="title"
      :visible.sync="upDialogVisible"
      width="30%"
      center>
      <span v-if="title === '升级'">当前用户已经购买: <font color="red">{{up.name}}</font> 且为: <font
        color="red">{{up.thread_num}}线程数</font> <br>到期时间: <font color="red">{{up.end_time}}</font><br>
        升级转化为: <font color="red">{{up.cur}}</font><br>转化后累加天数为: <font color="red">{{up.y_days}}</font><br> 如需更换会员，我们采用升级处理!</span>
      <span v-else-if="title === '抱歉'">
        <font color="red">您当前为包年会员，暂不支持月份进行续费</font>
        </span>
      <span v-else-if="title === '不支持'">
        <font color="red">暂不支持会员等级降低，请注册新号或联系客服处理</font>
        </span>
      <span v-else>
          <span>
          当前未到过期时间，是否进行续费?<br>
        </span>
        <span v-if="!!this.re">
          当前线程为: <font color="red">{{this.re.cur_thread_num}}<br></font>
          线程数转为: <font color="red">{{this.re.thread_num}}<br></font>
          转化天数为: <font color="red">{{this.re.time}}<br></font>
        </span>
        </span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="upDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="operation">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
  import qs from 'qs'

  export default {
    data() {
      return {
        centerDialogVisible: false,
        upDialogVisible: false,
        pattern_payment: '2',
        num: 1,
        sum_price: 0,
        vip_grade: [],
        vip: null,
        qr_img: '',
        order_id: '',
        pay_type: '',
        status: 0,
        is_wx: false,
        // 定时器的变量
        t: '',
        up: {
          'name': '',
          'end_time': '',
          'cur': '',
          'y_days': ''
        },
        re: '',
        title: '',
      }
    },
    async mounted() {
      await this.$http.getTradeType().then(res => {
        this.vip_grade = res.data
      })
    },
    methods: {
      async operation() {
        // 升级或者续费操作
        this.upDialogVisible = false
        if (this.title !== '抱歉' && this.title !== '不支持') {
          let login_name = localStorage.getItem('user_info')
          let data = {
            'trade_group_type': this.vip,
            'pay_type': this.pattern_payment,
            'login_name': login_name,
            'concurrent': this.num,
            'sum_price': this.sum_price,
            'up': 's'
          }
          this.$http.postPayQrCode(qs.stringify(data)).then(res => {
            this.qr_img = 'data:image/png;base64,' + res.data
            this.order_id = res.order_id
            this.pay_type = res.pay_type
            this.centerDialogVisible = true
            this.t = setInterval(this.polling, 1000)
          })
        }
      },
      async recharge() {
        if (!this.vip) {
          this.$alert('请选择充值类型', '提示', {
            confirmButtonText: '确定',
          });
        } else if (!this.pattern_payment) {
          this.$alert('请选择支付方式', '提示', {
            confirmButtonText: '确定',
          });
        } else {
          // 获取存储的login_name
          let login_name = localStorage.getItem('user_info')
          let data = {
            'trade_group_type': this.vip,
            'pay_type': this.pattern_payment,
            'login_name': login_name,
            'concurrent': this.num,
            'sum_price': this.sum_price
          }
          await this.$http.postPayQrCode(qs.stringify(data)).then(res => {
            if (res.code === 200) {
              this.qr_img = 'data:image/png;base64,' + res.data
              this.order_id = res.order_id
              this.pay_type = res.pay_type
              this.centerDialogVisible = true
              this.t = setInterval(this.polling, 1000)
            } else if (res.code === 300) {
              this.title = '升级'
              this.upDialogVisible = true
              this.up = res.data
            } else if (res.code === 301) {
              this.title = '续费'
              this.upDialogVisible = true
              this.re = res.data
            } else if (res.code === 310) {
              this.title = '抱歉'
              this.upDialogVisible = true
            } else if (res.code === 311) {
              this.title = '不支持'
              this.upDialogVisible = true
            }
          }).catch(err => {
            console.log('请求错误', err)
          })

        }
      },
      // 前端轮询查询订单状态
      polling() {
        this.$http.getOrderStatus(this.order_id, this.pay_type).then(res => {
          if (res.code === 200) {
            this.status = 1
          }
        }).catch(err => {
          console.log(err, 'err')
        })
        if (this.status === 1) {
          clearInterval(this.t)
          this.centerDialogVisible = false
          this.$router.replace('/main')
        }
      },
      handleBeforeClose(done) {
        this.$confirm('确认关闭支付？')
          .then(_ => {
            clearInterval(this.t)
            done();
          })
          .catch(_ => {
          });
      }
    },
    watch: {
      vip() {
        if (this.vip) {
          let item = this.vip_grade.find(item => {
            if (item.id === this.vip) {
              return item
            }
          })
          this.sum_price = item.price * this.num
        }
      },
      num() {
        let item = this.vip_grade.find(item => {
          if (item.id === this.vip) {
            console.log(item, item.price)
            return item
          }
        })
        if (this.vip) {
          this.sum_price = item.price * this.num
        }
      }
    }
  }
</script>
<style scoped>
  .qrcode {
    width: 300px;
    height: 300px;
  }

  .vip_select {
    font-size: 16px;
    color: #000;
    padding-top: 20px;
    padding-left: 20px;
  }

  .vip_select >>> .el-radio__input.is-checked + .el-radio__label {
    color: #FF470A;
  }

  .all_pay >>> .el-radio__input.is-checked .el-radio__inner {
    border-color: #FF470A;
    background: #FF470A;
  }

  .all_pay >>> .el-radio__inner {
    border-color: #999;
  }

  .all_pay >>> .el-radio__inner:hover {
    border-color: #FF470A;
  }

  .pay-opt {
    padding-left: 20px;
    padding-top: 20px;
  }

  .pay-opt >>> .el-radio.is-bordered {
    height: 57px;
    padding: 7px 28px;
    border-color: #bbb;
  }

  .pay-opt >>> .el-radio.is-bordered.is-checked {
    border-color: #FF470A;
  }

  .pay-opt >>> .el-radio__input {
    bottom: 15px;
    right: 4px;
  }

  .title {
    padding-top: 20px;
  }

  .bold {
    font-weight: 600;
  }

  .sum_price {
    color: #FF470A;
    font-weight: 600;
    font-size: 18px;
    display: inline-block;
    margin-top: 20px;
    width: 162px;
    padding-left: 20px;
  }

  .btn {
    height: 28px;
    line-height: 28px;
    color: white;
    border: 0;
    background-color: #A7231E;
    font-weight: bold;
    font-size: 14px;
    padding: 5px 10px;
    margin: 0 30px;
  }

  .btn:hover {
    cursor: pointer;
    background-color: rgb(207, 50, 44);
  }

  .notice {
    margin-top: 20px;
    font-size: 13px;
  }
</style>
